import type { OnDemandItem } from "@ca.vmedia.tv/domains";
import { SlideDataType, type SlideData } from "../types";

export class MostPopularSlideData implements SlideData {

    private item: OnDemandItem;

    constructor(item: OnDemandItem) {
        this.item = item;
    }

    getId() {
        return `${this.item.id}`;
    }
 
    getImage() {
        return this.item.image ?? '';
    }
    
    getPlayItem() {
        return this.item;
    }

    getClass() {
        return 'most-popular-card';
    }

    getClassActive() {
        return 'most-popular-card_active';
    }

    getClassLock() {
        return 'most-popular-card_lock';
    }

    getType() {
        return SlideDataType.MostPopular;
    }

    getName(): string {
        if (this.isNotEmpty(this.item.seriesName)) {
            return this.item.seriesName!;
        }
        if (this.isNotEmpty(this.item.shortName)) {
            return this.item.shortName!;
        }
        if (this.isNotEmpty(this.item.name)) {
            return this.item.name!;
        }
        return "";
    }

    isNotEmpty(val: string | null): boolean {
        return (val != null && val.length > 0);
    }
}
